export default __webpack_public_path__ + "static/media/hot-tea.7d33224f.webp";